import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './NotFound.css';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="notfound-page">
      <motion.div
        className="notfound-content"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <motion.div
          className="notfound-emoji"
          animate={{ rotate: [0, -10, 10, -10, 0] }}
          transition={{ duration: 2, repeat: Infinity, repeatDelay: 3 }}
        >
          📖
        </motion.div>
        <h1 className="notfound-title">404</h1>
        <p className="notfound-subtitle">Cette page s'est perdue entre deux chapitres...</p>
        <p className="notfound-text">Le livre que tu cherches n'existe pas, ou a été déplacé dans une autre dimension littéraire.</p>
        <div className="notfound-actions">
          <motion.button
            className="btn btn-primary"
            onClick={() => navigate('/')}
            whileTap={{ scale: 0.95 }}
          >
            🏠 Retour à l'accueil
          </motion.button>
          <motion.button
            className="btn btn-ghost"
            onClick={() => navigate('/explore')}
            whileTap={{ scale: 0.95 }}
          >
            🔍 Explorer les livres
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
}